import React from "react";
import SlideshowHero from "../components/SlideshowHero";

// Put these files here: doctor-frontend/src/assets/slides/
import img1 from "../assets/slides/aiims_building_1.jpg";
import img2 from "../assets/slides/aiims_building_2.jpg";
import img3 from "../assets/slides/aiims_department_1.jpg";

export default function DashboardLanding() {
  return (
    <div className="p-6">
      <SlideshowHero
        images={[img1, img2, img3]}
        caption="Department of Community Medicine & Family Medicine — AIIMS Jodhpur"
        intervalMs={5000}
        height="70vh"
      />
    </div>
  );
}
